// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3dOd1","select":"Header_select__1wivG","clinic":"Header_clinic__2-TUY"};